/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import {useSelector} from "react-redux";
import {getRoleBasedConfiguration} from "../../../selectors/generic";
import LoginCard from "../ecom/LoginCard";
import {clickAwayListener} from "../../hoc/hooks";
import {Popover} from "../../atoms/bootstrap/Popover";
import Block from "../../atoms/layout/Block";
import ProductPackageSelector from "./ProductPackageSelector";


function ProductDetailsRestricted({ loggedIn, variations, obsolete }) {

    const roleConfig = useSelector(getRoleBasedConfiguration);
    const ref = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const callback = React.useCallback(clickAwayListener(ref, () => open && setOpen(false), open), [ref, open]);
    React.useEffect(callback, [open]);

    if (loggedIn) {
        return <>
            <ProductPackageSelector variations={variations} obsolete={obsolete} restrictedView/>
            {(roleConfig?.productDetailsMessage || roleConfig?.productDetailsBtnText) &&
            <div className="p-padding-md">
                {roleConfig.productDetailsMessage &&
                <p dangerouslySetInnerHTML={{__html: roleConfig.productDetailsMessage}}/>}
                {roleConfig.productDetailsBtnLink && roleConfig.productDetailsBtnText &&
                <a href={roleConfig.productDetailsBtnLink} className="btn btn-secondary">
                    {roleConfig.productDetailsBtnText}
                </a>}
            </div>}
        </>;
    }

    return <React.Fragment>
        <ProductPackageSelector variations={variations} obsolete={obsolete} restrictedView/>
        <LoginCard text={roleConfig && roleConfig.productDetailsMessage}
                   buttonText={roleConfig && roleConfig.productDetailsBtnText}/>
        <div className={"login-card__popover"} ref={ref}>
            <Block hide={!roleConfig} onClick={() => setOpen(!open)}>
                <span className={"text-style2 p-cursor-pointer"}>
                    {roleConfig && roleConfig.productDetailsLoginText}
                </span>
                <Popover open={open} direction={"bottom"}>
                    <span dangerouslySetInnerHTML={{__html: roleConfig && roleConfig.productDetailsLoginDescription}}/>
                </Popover>
            </Block>
        </div>
    </React.Fragment>
}

export default ProductDetailsRestricted;
